'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DOTCOM = 'dotcom';
var SOLE24PLUS = '24plus';
var SOLE24CMP = 'cmp';

exports.DOTCOM = DOTCOM;
exports.SOLE24CMP = SOLE24CMP;
exports.SOLE24PLUS = SOLE24PLUS;
